import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import PhotoGalleryOverlay from './PhotoGalleryOverlay';
import PhotoThumbnail from './PhotoThumbnail';
const MAX_VISIBLE_IMAGES = 4;
const GRID_COLS = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
};
export default function PhotoList({ images, testId, maxImagesCount = MAX_VISIBLE_IMAGES }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const columns = Math.min(maxImagesCount, MAX_VISIBLE_IMAGES);
    const { hasMoreImages, remainingCount, visibleImages } = useMemo(() => {
        return {
            hasMoreImages: images.length > maxImagesCount,
            remainingCount: images.length - maxImagesCount,
            visibleImages: images.slice(0, maxImagesCount),
        };
    }, [images, maxImagesCount]);
    const handleImageClick = useCallback((index) => {
        setSelectedImageIndex(index);
        setIsModalOpen(true);
    }, []);
    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: `grid ${GRID_COLS[columns] ?? 'grid-cols-4'} gap-3`, "data-testid": testId, children: visibleImages.map((image, index) => (_jsx(PhotoThumbnail, { image: image, index: index, testId: testId.append('image').append(index.toString()), onClick: handleImageClick, remainingCount: hasMoreImages && index === maxImagesCount - 1 ? remainingCount : undefined }, index))) }), isModalOpen && (_jsx(PhotoGalleryOverlay, { images: images, isOpen: isModalOpen, onClose: handleCloseModal, testId: testId.append('modal'), initialIndex: selectedImageIndex }))] }));
}
